module.exports = __webpack_public_path__ + "img/logo1.7cd63e59.png";